import { PatientAccountTokenResponse } from "@shared/dtos/responses/patientAccountResponses.dto"

import { axiosPatient } from "./generic/AxiosInterceptor/AxiosInterceptor"

export interface ExtendSessionOptions {
  /** Suppress the error toast on failure — for background extends the patient did not initiate. */
  suppressErrorToast?: boolean
}

export const extendSession = async ({
  suppressErrorToast = false,
}: ExtendSessionOptions = {}): Promise<PatientAccountTokenResponse> => {
  const resp = await axiosPatient({
    url: "/patient/patientaccount/extendsession",
    method: "post",
    suppressErrorToast,
  })
  return resp.data
}
